<template>
  <settings-modal
    :locked="isLoading"
    class="t-transaction-fee-delete-modal"
  >
    <span
      slot="heading"
      class="font-weight-bold"
    >Delete "{{ transactionFee.name }}" transaction fee</span>

    <error-alert
      :error="error"
      class="mt-4"
    />

    <template slot="actions">
      <v-btn
        class="t-confirm-button"
        color="error"
        medium
        flat
        :disabled="isLoading"
        @click="onDeleteButtonClick"
      >delete transaction fee</v-btn>

      <v-btn
        class="t-cancel-button"
        color="primary"
        medium
        flat
        :disabled="isLoading"
        @click="onCloseButtonClick"
      >cancel</v-btn>
    </template>
  </settings-modal>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'

  // Services
  import ApiRequest from '@/services/ApiRequests/ApiRequest'
  import FeeApi from '@/services/Api/FeeApi'

  // Mixins
  import modal from '@/mixins/modal'
  import form from '@/mixins/form'

  // Components
  import SettingsModal from '@/components/modals/SettingsModal'
  import ErrorAlert from '@/components/ui/ErrorAlert'

  export default {
    name: 'TransactionFeeDeleteModal',
    components: {
      ErrorAlert,
      SettingsModal
    },
    mixins: [modal, form],
    data () {
      return {
        error: undefined,
        isLoading: false,
        deleteTransactionFeeApiRequest: new ApiRequest(FeeApi.deleteTransactionalFee)
      }
    },
    computed: {
      ...mapGetters('modal', ['modal']),
      transactionFee () {
        return this.modal.data.transactionFee
      },
      redirectPath () {
        return this.modal.data.redirectPath
      },
      successCallback () {
        return this.modal.data.successCallback
      }
    },
    methods: {
      ...mapActions('modal', ['closeModal', 'showModal']),
      onDeleteButtonClick () {
        this.setError(null)
        this.setIsLoading(true)

        this.deleteTransactionFeeApiRequest.execute(this.transactionFee.id)
          .then(() => {
            this.showModal({
              name: 'SuccessFlashModal',
              data: {
                message: 'Transaction fee has been successfully deleted.',
                redirectPath: this.redirectPath
              },
              options: {
                onComplete: this.successCallback
              }
            })
          })
          .catch((error) => this.setError(error))
          .finally(() => this.setIsLoading(false))
      },
      onCloseButtonClick () {
        this.closeModal()
      },
      setIsLoading (isLoading) {
        this.$set(this, 'isLoading', isLoading)
      }
    }
  }
</script>
